import {LOGIN, REGISTER} from 'features/menu/constants';

export const RADIO_BUTTON_LIST = [
    {
        value: LOGIN,
        dataName: 'loginAccount',
        dataValue: 'loginTab',
        text: 'I have an account (Login)',
    },
    {
        value: REGISTER,
        dataName: 'createAccount',
        dataValue: 'registerTab',
        text: 'I am new here (Create an account)',
    },
];
